import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import Categories from './Categories';

const Footer = () => {


  const scrollTo = (id) => {
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 1000);
  };


  return (
    /* White background with a subtle gray top border and an orange-tinted shadow */
    <footer className="bg-white text-[#333] py-16 px-6 md:px-16 font-raleway border-t border-gray-100 shadow-[0_-10px_20px_-5px_rgba(255,170,0,0.05)]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

        {/* Brand Section */}
        <div className="lg:col-span-1">
          <h2 style={{ fontFamily: 'Montserrat, sans-serif' }} className="text-2xl font-black tracking-tighter mb-6 uppercase text-black">
            ELECTRO <span className="text-[#FFAA00]">TITAN</span>
          </h2>
          <p className="text-sm leading-relaxed mb-8 text-gray-600 font-medium">
            Votre destination de confiance pour achat des appareils d'électroménager au Maroc . Qualité première et service après vente garantie          
          </p>
          <div className="space-y-4 text-sm font-semibold">
            <Link to={"tel:+212630681618"} className="flex items-center gap-3 group">
              <Phone size={18} className="text-[#FFAA00]" />
              <span className="group-hover:text-black transition-colors">+212 6 30 68 16 18</span>
            </Link>

            <Link to={"tel:+212640033322"} className="flex items-center gap-3 group">
              <Phone size={18} className="text-[#FFAA00]" />
              <span className="group-hover:text-black transition-colors">+212 6 40 03 33 22</span>
            </Link>

            <div className="flex items-center gap-3 group">
              <Mail size={18} className="text-[#FFAA00]" />
              <span className="group-hover:text-black transition-colors">contact@titanelectro.ma</span>
            </div>
            <div className="flex items-start gap-3 group">
              <MapPin size={18} className="text-[#FFAA00] shrink-0" />
              <span className="group-hover:text-black transition-colors">8, Avenue allal al arbi al alaoui Hay Salam, SALE MAROC</span>
            </div>
          </div>
        </div>

        {/* Column 2: Categories */}

        <Categories />

        {/* Column 3: Information */}
        <div>
          <h3 style={{ fontFamily: 'Montserrat, sans-serif' }} className="font-bold mb-8 uppercase text-[11px] tracking-[0.2em] text-black border-l-4 border-[#FFAA00] pl-3">
            Information
          </h3>
          <ul className="space-y-4 text-sm font-medium text-gray-500">
            <li><Link to={"/"} onClick={() => scrollTo("about")} className="hover:text-[#FFAA00] transition-colors">À Propos</Link></li>
            <li><Link to="/nos-produits" className="hover:text-[#FFAA00] transition-colors">Nos Produits</Link></li>
            <li><Link to="/conditions-generales" className="hover:text-[#FFAA00] transition-colors">Conditions Générales</Link></li>
          </ul>
        </div>

        {/* Column 4: Assistance */}
        <div>
          <h3 style={{ fontFamily: 'Montserrat, sans-serif' }} className="font-bold mb-8 uppercase text-[11px] tracking-[0.2em] text-black border-l-4 border-[#FFAA00] pl-3">
            Assistance
          </h3>
          <ul className="space-y-4 text-sm font-medium text-gray-500">
            <li><Link to="/contact" className="hover:text-[#FFAA00] transition-colors">Contactez Nous</Link></li>
            <li><Link to="/adresse" className="hover:text-[#FFAA00] transition-colors">Notre Adresse</Link></li>
            <li><Link to="/faq" className="hover:text-[#FFAA00] transition-colors">FAQ</Link></li>
          </ul>
        </div>



      </div>

      {/* Bottom Footer Bar */}
      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-6">
        <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-gray-400">
          © 2026 <span className="text-black">ELECTRO TITAN</span> — Électroménager de Qualité
        </p>

      </div>
    </footer>
  );
};

export default Footer;